import React from 'react';
import classNames from 'classnames';
import { useI18n } from 'nordic/i18n';
import { Typography } from '@andes-landings/typography';
import { misc, ui } from '@credits-utils/constants';
import { Image } from 'nordic/image';
import CarouselSnapped, { CarouselSnappedSlide } from '@andes/carousel-snapped';
import { makeRedirection, trackAction } from '@/utils';
import SharedPropsContext from '../../../../../contexts/SharedProps';
import { getMarketingSectionContent } from '../../content/marketingSection';
import SellerItem from '../../../../../components/SellerItem';
import Miscelanea from '../Miscelanea';

const { BACKGROUND, DEVICE_TYPE } = misc;
const { TYPOGRAPHY } = ui;

const MarketingSection = () => {
  const {
    apiPicture,
    deviceType,
    availableSeasonal,
    tracks,
    isYellowTheme,
    isWebView,
    seeCategories,
    baseUrl,
    queryParams,
    links,
  } = React.useContext(SharedPropsContext);

  const { i18n } = useI18n();

  const { seeAllBenefits, waveImages } = getMarketingSectionContent({ i18n });
  const { sellers, title, subtitle, image } = availableSeasonal;
  const { url: urlImage, fileExtension } = apiPicture;

  const showPagination = deviceType === DEVICE_TYPE.DESKTOP && sellers.length > 4;
  const showArrows = deviceType === DEVICE_TYPE.DESKTOP && sellers.length > 4;

  const trackInfoMelidata = {
    ...tracks.melidata.events.buyersPage.marketingSection.goToSpecificCategory,
    event_data: {
      category_id: '0',
    },
  };
  const melidataEvent = tracks.melidata.events.buyersPage.marketingSection.goToSellerSite;

  const getNumber = (n) => {
    if (n % 2 === 0 && n !== 2) {
      return n / 2;
    }
    return Math.trunc(n / 2) + 1;
  };

  const getSlidesPerView = () => {
    if (deviceType === DEVICE_TYPE.DESKTOP) return sellers.length >= 4 ? 4 : sellers.length;

    return getNumber(sellers.length);
  };

  const waves = deviceType === DEVICE_TYPE.DESKTOP ? waveImages.desktop : waveImages.mobile;

  const getSizeImage = deviceType === DEVICE_TYPE.DESKTOP ? '-O' : '-V';

  const mktSectionClassNames = classNames('marketing-section', {
    'marketing-section-yellow': isYellowTheme,
  });

  const handleClick = () => {
    trackAction({
      melidata: trackInfoMelidata,
    });

    makeRedirection({
      callback: isWebView ? seeCategories : `${baseUrl}${links.allCategories}?${queryParams ?? ''}`,
      isWebView,
    });
  };
  return (
    <>
      <div className="marketing-image-wave">
        <Image
          className="marketing-image-wave-top"
          onload="on"
          src={waves.top}
          alt="marketing-image-top"
        />
      </div>
      <section className={mktSectionClassNames} id="marketing-section">
        <div className="marketing-section__header">
          <div className="marketing-section__header-info">
            {deviceType === DEVICE_TYPE.DESKTOP ? <Miscelanea /> : <></>}
            <Typography
              className="marketing-section__header-info-title"
              component={TYPOGRAPHY.COMPONENT.H3}
              type={TYPOGRAPHY.TYPE.TITLE}
              size={TYPOGRAPHY.SIZE.XL}
              color={TYPOGRAPHY.COLOR.INVERTED}
            >
              {title}
            </Typography>
            <h2 className="marketing-section__header-info-subtitle">
              {subtitle}
            </h2>
          </div>
          <div className="marketing-section__header-image">
            <Image
              onload="on"
              src={urlImage + image + getSizeImage + fileExtension}
              alt="marketing-section-image"
            />
          </div>
        </div>
        <div className="marketing-section__sellers">
          <div className="marketing-section__sellers-content">
            <CarouselSnapped
              srLabel="Marketing Logos"
              pagination={
                showPagination
                  ? {
                    mode: BACKGROUND.DARK,
                  }
                  : false
              }
              scroll="hidden"
              arrows={showArrows}
              slidesPerView={getSlidesPerView()}
              spacing={0}
              strictBoundaries={deviceType !== DEVICE_TYPE.DESKTOP}
            >
              {sellers.map((seller) => (
                <div
                  className="marketing-section__sellers-content-item"
                  key={`marketing-section-${seller.id}`}
                >
                  <CarouselSnappedSlide ey={`carouselSlider-${seller.id}`}>
                    <SellerItem
                      key={`seller-item-${seller.id}`}
                      seller={seller}
                      melidataEvent={melidataEvent}
                      fontWhite
                    />
                  </CarouselSnappedSlide>
                </div>
              ))}
            </CarouselSnapped>
          </div>
        </div>
        <Typography
          className="marketing-section__link"
          component={TYPOGRAPHY.COMPONENT.A}
          onClick={handleClick}
        >
          {seeAllBenefits}
        </Typography>
      </section>
      <div className="marketing-image-wave">
        <Image
          className="marketing-image-wave-bottom"
          onload="on"
          src={waves.bottom}
          alt="marketing-image-top"
        />
      </div>
    </>
  );
};

export default MarketingSection;
